import React, { useState, useEffect } from 'react';
import { MDBDataTable } from 'mdbreact';
import { Form, Col, Row } from 'react-bootstrap';
import { Button, Container } from '@mui/material';
import Swal from 'sweetalert2';
import Select from "react-select";
import { RiDeleteBinFill } from "react-icons/ri";
import { FaEdit } from "react-icons/fa";
import { FaEye } from "react-icons/fa6";
import "../../assets/css/custom.css";
import { baseURL } from '../base_url';
import axios from 'axios';
import { PuffLoader } from 'react-spinners';
import moment from 'moment';

const Access = () => {
  const [DisplyForm, setDisplyForm] = useState(false)
  const [roleName, setRoleName] = useState('')
  const [menuItems, setMenuItems] = useState('')
  const [isActive, setIsActive] = useState(false)
  const [viewEditButton, setViewEditButton] = useState(true)
  const [isEdited, setIsEdited] = useState('');
  const [checkboxValues, setCheckboxValues] = useState([]);
  const columnList = ['View','Add','Edit','Export','Delete']
  const exceptSelectBox = ['Dashboard','Access Setup','User']
  const [loading, setLoading] = useState(false);
  const loggedInUser = sessionStorage.getItem("tm_token");
  const foundUser = JSON.parse(loggedInUser);
  const [accessDetails, setAccessDetails] = useState([]);
  const [updateFlag, setUpdateFlag] = useState(false);

  useEffect(() => {
    axios.get(baseURL + "/get_modules").then((res) => {
      const menuList = res.data.map((val1) => {
        return { "name": val1.name }
      })
      setMenuItems(menuList)
    });
  },[]);
  useEffect(() => {
    setLoading(true);
    axios.get(baseURL + "/get_access_setup?status=all&admin_id=" + foundUser['tm_id']).then((res) => {
      var j = 1;
      if(res.data.status === '1'){
        let rowsData = [];
        const myDataSet = res.data.data;
        for (var index = 0; index < res.data.data.length; index++) {
          let rowItem = {};
          const val = myDataSet[index];
          rowItem["id"] = j++;
          rowItem["r_name"] = val.role_name;
          rowItem["c_name"] = val.c_name;
          rowItem['c_date'] = moment(new Date(val.created_datetime)).format('MM/DD/YYYY hh:mm A');
          rowItem['status'] = (val.is_active === 'True' ? 'Active':'In-Active');
          rowItem['action'] = (<React.Fragment><FaEye title='View' onClick={() => vieweditHandle("view-"+val._id)} style={{ marginLeft: '8px', cursor: 'pointer' }}/> {foundUser['tm_accessRole']['Access Setup']['Edit'] == true && (<>|<FaEdit title='Edit' onClick={() => vieweditHandle("edit-"+val._id)} style={{ marginLeft: '8px', cursor: 'pointer' }}/></>)} {foundUser['tm_accessRole']['Access Setup']['Delete'] == true && (<>| <RiDeleteBinFill  title='Delete' onClick={() => deleteHandle(val._id)} style={{ cursor: 'pointer' }}/></>)}</React.Fragment>)
          rowsData.push(rowItem)
        }
        setAccessDetails(rowsData);
      }else{
        setAccessDetails([]);
      }
      setLoading(false);
    });
  },[updateFlag]);

  const handleCheckboxChange = (itemName, colIndex) => {
    const newCheckboxValues = { ...checkboxValues };
    newCheckboxValues[itemName] = {
      ...newCheckboxValues[itemName],
      [colIndex]: !newCheckboxValues[itemName]?.[colIndex]
    };
    setCheckboxValues(newCheckboxValues);
  };

  const deleteHandle = (id) => {
    Swal.fire({
      title: 'Are you sure you want to delete?',
      showCancelButton: true,
      confirmButtonText: 'Yes',
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(baseURL + "/access_delete",{"id":id,"admin_id":foundUser['tm_id']}).then((res) => {
          if(res.data.status === '1'){
            Swal.fire('Deleted!', 'Access has been deleted.', 'success')
          }else{
            Swal.fire("Something went wrong.")
          }
          setLoading(false);
        })
        setUpdateFlag(!updateFlag);
      }
    })
  }
  const vieweditHandle = (id) => {
    setLoading(true);
    const explodedArray = id.split('-');
    axios.post(baseURL + "/get_access_setup_single",{"id":explodedArray[1]}).then((res) => {
      if(res.data.status === '1'){
        setDisplyForm(true)
        setRoleName(res.data.data.role_name)
        const validJSONString = res.data.data.selected_access
        .replace(/'/g, '"')  // Replace single quotes with double quotes
        .replace(/True/g, 'true')  // Replace True with true
        .replace(/False/g, 'false');
        const parsedSelectedAccess = JSON.parse(validJSONString);
        setCheckboxValues(parsedSelectedAccess);
        if (res.data.data.is_active === 'True'){
          setIsActive(true);
        }else{
          setIsActive(false);
        }
        if (explodedArray[0] === 'view'){
          setViewEditButton(false)
        }else{
          setIsEdited(res.data.data._id)
          setViewEditButton(true)
        }
      }else{
        Swal.fire("Something went wrong.")
        return;
      }
      setLoading(false);
    })
  }
  const handleIsActive = (e) => {
    setIsActive(e.target.checked);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsEdited('');
    setViewEditButton(true)
    setCheckboxValues([])
    setRoleName('')
    setDisplyForm(true)
    setViewEditButton(true);
  }
  function hasTrueProperty(obj) {
    for (let key in obj) {
        if (obj[key] === true) {
            return true;
        } else if (typeof obj[key] === 'object') {
            if (hasTrueProperty(obj[key])) {
                return true;
            }
        }
    }
    return false;
  }
  const handleSubmitForm = (e) => {
    e.preventDefault();
    if (roleName.toString().trim() === '') {
      Swal.fire("Please enter Role Name.")
      return;
    }
    const hasTrue = hasTrueProperty(checkboxValues);
    if (hasTrue == false) {
      Swal.fire("Please select atleast one access.")
      return;
    }
    setLoading(true);
    axios.post(baseURL + "/create_access", {
      'admin_id': foundUser['tm_id'],
      'role_name': roleName.toString().trim(),
      'selected_access': checkboxValues,
      'status': isActive,
      'is_edited': isEdited
    }).then((res) => {
      setLoading(false);
      if (res.data.status === 'success'){
        setDisplyForm(false)
        setCheckboxValues([])
        setRoleName('')
        let msg = "Role Name - " + roleName.toString() + " created successfully.";
        Swal.fire({icon: 'success',
          text: msg
        })
      }else if (res.data.status === 'duplicate'){
        Swal.fire("<b>"+roleName.toString() + "</b> already exist, Please try with different role name.")
        return;
      }else if (res.data.status === 'updated'){
        setDisplyForm(false)
        setCheckboxValues([])
        setRoleName('')
        let msg = "Role Name - " + roleName.toString() + " updated successfully.";
        Swal.fire({icon: 'success',
          text: msg
        })
      }else{
        Swal.fire("Something went wrong.")
        return;
      }
      setUpdateFlag(!updateFlag);
    })
  }
  const cancelForm = (e) => {
    e.preventDefault();
    setDisplyForm(false)
  }
  const data = {
    columns: [
      {
        label: 'S.No',
        field: 'id',
      },
      {
        label: 'Role Name',
        field: 'r_name',
      },
      {
        label: 'Create By',
        field: 'c_name',
      },
      {
        label: 'Created DateTime',
        field: 'c_date',
      },
      {
        label: 'Status',
        field: 'status',
      },
      {
        label: 'Action',
        field: 'action',
      },
    ],
    rows: accessDetails
  };
  const searchOptions = {
      text: 'Search by name', // Placeholder text for the search input
      showSearch: true, // Show the search input
      searchLabel: 'Search:', // Label for the search input
    };
      
  return(
      <div className='body_class'>
        {loading ? (
            <div className="loader-overlay">
                <div className="loader">
                <PuffLoader color="#00308F" loading={true} size={200} />
                </div>
            </div>
        ) : ("")}
          <div className='container-fluid'>
            {!DisplyForm ? (
            <>
            <div className="mt-5">
            {foundUser['tm_accessRole']['Access Setup']['Add'] == true &&
              <Button size="large" type="submit" variant="contained" onClick={handleSubmit}>
                  + Add Role
              </Button>
            }
            </div>
            <div className="row mt-1">
              <div className="col-md-12">
                <MDBDataTable
                  bordered
                  data={data}
                  large={false}
                  displayEntries={false}
                  search={searchOptions}
                  noBottomColumns={true}
                  className="pagination-right-aligned"
                  searching={true}
                />
              </div>
            </div>
            </>
            ):(
              <>
              <h4>Add Access</h4>
              <div className='mt-4'>
              <div className='container-fluid'>
              <Form onSubmit={handleSubmitForm}>
              <div className='p-3 madatory_fields'>
                <div className="form_section">**Mandatory Fields**</div>
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextCN">
                    <Form.Label column sm="2">
                      Role Name *
                    </Form.Label>
                    <Col sm="5">
                      <Form.Control type='text' value={roleName} onChange={(e)=>setRoleName(e.target.value)} placeholder='Role Name' />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextCP">
                    <Form.Label column sm="2">
                      Select Access *
                    </Form.Label>
                    <Col sm="7">
                      <table className='table table-bordered'>
                        <thead>
                            <tr>
                                <th></th>
                                <th>View</th>
                                <th>Add</th>
                                <th>Edit</th>
                                <th>Export</th>
                                <th>Delete</th>
                            </tr>
                        </thead>
                        <tbody>
                          {menuItems.map((menuItem, rowIndex) => (
                            <tr key={menuItem['name']}>
                              <td className='fw-bold'>{menuItem['name']}</td>
                              {columnList.map((colIndex) => (
                                <td key={colIndex} className='text-center'>
                                  <Form.Check
                                    type="checkbox"
                                    id={`checkbox-${menuItem['name']}-${colIndex}`}
                                    checked={checkboxValues[menuItem['name']]?.[colIndex] || false}
                                    onChange={() => handleCheckboxChange(menuItem['name'], colIndex)}
                                  />
                                </td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </Col>
                  </Form.Group>
              </div>
                  <div style={{textAlign:"center"}} className=''>
                  <Form.Group as={Row} className="mt-4" controlId="formPlaintextCheckbox">
                    <Col sm="5"></Col>
                        <Col sm="1">
                        <Form.Check
                            type="checkbox"
                            id="checkbox"
                            label="Is&nbsp;Active"
                            checked={isActive}
                            onChange={handleIsActive}
                        />
                        </Col>
                    </Form.Group>
                    {viewEditButton && 
                      <Button variant="contained" type="submit">
                        Submit
                      </Button>
                    }
                    <Button variant="outlined" type="submit" className="m-4" onClick={cancelForm}>
                      Cancel
                    </Button>
                  </div>
                </Form>
              </div>
              </div>
              </>
            )}
          </div>
      </div>
    )
}

export default Access;